"use client";

import dynamic from "next/dynamic";
import type { DetailDataQuery } from "@/types/generated";

// Lazy load DetailPopup - it's a modal that shows conditionally after page load
// Not needed for initial render
const DetailPopup = dynamic(() => import("./DetailPopup"), {
  ssr: false,
  loading: () => null,
});

interface LazyDetailPopupProps {
  readonly detailPopupData: DetailDataQuery;
}

export default function LazyDetailPopup({
  detailPopupData,
}: LazyDetailPopupProps) {
  return <DetailPopup detailPopupData={detailPopupData} />;
}
